import { Button, Typography } from '@breetometer/components';
import { Animation } from 'BreetComponents';
import { useModalApi } from 'BreetHooks';
import { closeModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

import alert from '@/assets/lottie/alert.json';

import { type IDialogAlert } from './DialogAlert.helpers';

const DialogAlert = ({ title, description }: IDialogAlert) => {
	const { getModalProps, openModalDirect } = useModalApi();

	const dispatch = useAppDispatch();

	const modal = getModalProps('alert');

	const modalMetadata = modal?.metadata as
		| { title: string; description: string; action?: { title: string; actionType: 'support'; preMessage?: string } }
		| undefined;

	const handleAction = useCallback(() => {
		openModalDirect({ id: 'contactSupport' });

		dispatch(closeModal('alert'));
	}, [dispatch, openModalDirect]);

	return (
		<div className='dialog-alert bg-primary-500'>
			<Animation
				animationData={alert}
				height={150}
				width={150}
			/>

			<Typography
				as='h1'
				className='color-neutral-50'
			>
				{title ?? modalMetadata?.title}
			</Typography>
			<Typography className='color-primary-100'>{description ?? modalMetadata?.description}</Typography>

			{modalMetadata?.action && (
				<Button
					onClick={handleAction}
					variant='tertiary'
				>
					{modalMetadata.action.title}
				</Button>
			)}
		</div>
	);
};

export default DialogAlert;
